





























































import {
  AuthClientServiceProxy,
  DictServiceProxy,
} from "@/service-proxies/app-v2/system.service-proxies";
import { columns } from "./components/column";
import Add from "./components/create.vue";
import { clientList, dictList } from "./api";
const clientService = new AuthClientServiceProxy();
const dictService = new DictServiceProxy();
const options = {
  listApi: clientService.list.bind(clientService),
  deleteApi: clientService.remove.bind(clientService),
  dictListApi: dictService.list.bind(dictService),
};

export default {
  components: { Add },
  computed: {
    columns() {
      return columns.map((item) => {
        return {
          ...item,
          title: this.$t(item.title),
        };
      }); // 表单配置
    },
    rowSelection() {
      const { selectedRowKeys }: any = this;
      return {
        selectedRowKeys,
        onChange: (selectedRowKeys: any) => {
          this.selectedRowKeys = selectedRowKeys;
        },
      };
    },
  },
  data() {
    return {
      dialog: false,
      ...options,
      dataSource: [], // 列表数据
      dictList: [], //字典
      totalContent: 0, // 总数
      query: {
        size: 30,
        current: 1,
        clientId: '',
        clientSecret: '',
      },
      dictQuery: {
        code: "grant_type",
      },
      form: {
        accessTokenValidity: "", // 令牌过期时间
        refreshTokenValidity: "", // 刷新令牌时间
        authorizedGrantTypes: "", // 授权类型string
        grantTypes: [], // 授权类型 array
        autoapprove: "", // 自动授权
        clientId: "", // 客户端id
        clientSecret: "", // 客户端密钥
        resourceIds: "", // 资源集合
        scope: "", // 授权范围
        authorities: "", // 权限
        id: "",
        additionalInformation: "", // 附加说明
        webServerRedirectUri: "", // 回调地址
        disabled: false, // 查看/编辑
      },
      selectedRowKeys: [],
      Rowkey: "", // 所选表单行
    };
  },
  created() {
    this.getList();
    this.getDict();
  },
  methods: {
    handleCreate() {
      this.dialog = true;
      this.form = {
        accessTokenValidity: "",
        refreshTokenValidity: "",
        authorizedGrantTypes: "",
        grantTypes: [],
        autoapprove: "",
        clientId: "",
        clientSecret: "",
        resourceIds: "",
        scope: "",
        authorities: "",
        id: "",
        additionalInformation: "",
        webServerRedirectUri: "",
        disabled: false,
      };
    },
    handleSearch(){
      this.query.current = 1;
      this.getList();
      
    },
    handleDelete() {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      let that = this;
      let ids ='';
      if(this.selectedRowKeys.length){
        ids = this.selectedRowKeys.join(',');
      }else{
        ids = this.selectedRowKeys[0]
      }
      this.$confirm({
        content: '是否确定删除',
        onOk() {
          that.deleteApi(ids).then(res=>{
            that.selectedRowKeys = [];
            that.$message.success(that.$t("delete_success"));
            that.getList();
          })
        },
      });
    },
    handleUpdate() {
      this.dialog = false;
      this.getList();
    },
    handleEdit(data) {
      let item = Object.assign({}, data);
      item.disabled = false;
      if (item.authorizedGrantTypes) {
        if (item.authorizedGrantTypes.indexOf(",") != -1) {
          item.grantTypes = item.authorizedGrantTypes.split(",");
        } else {
          item.grantTypes = [item.authorizedGrantTypes];
        }
      }
      this.form = item;
      this.dialog = true;
    },
    handleRead(data){
      let item = Object.assign({}, data);
      item.disabled = true;
      if (item.authorizedGrantTypes) {
        if (item.authorizedGrantTypes.indexOf(",") != -1) {
          item.grantTypes = item.authorizedGrantTypes.split(",");
        } else {
          item.grantTypes = [item.authorizedGrantTypes];
        }
      }
      this.form = item;
      this.dialog = true;
    },
    async getList() {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const that = this;
      clientList(this.query)
        .then((res) => {
          const { data } = res.data;
          if (data.records.length) {
            that.totalContent = data.total;
            that.dataSource = data.records;
          }else{
            this.dataSource = [];
            this.totalContent = 0;
          }
        })
        .catch((err) => {
          that.$message.error(err);
        });
    },
    getDict() {
      this.dictListApi(this.dictQuery.code).then((res) => {
        const { children } = res.data[0];
        if (children) {
          this.dictList = children;
        }
      });
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      // const that = this;
      // dictList({code:'grant_type'})
      //   .then((res) => {
      //     const { children } = res.data[0];
      //     if(children.length){
      //       that.dictList = children;
      //     }
      //     console.log(children);

      //   })
      //   .catch((err) => {
      //     that.$message.error(err);
      //   });
    },
    pageIndexchange(current: any) {
      this.query.current = current;
      this.getList();
    },
    totalFanyi(number: any) {
      const total = this.$t("Total…items");
      return total.replace("{0}", number);
    },
  },
};
